import { Skeleton, Typography, useMediaQuery } from '@mui/material';
import { Box, Container } from '@mui/system';
import React from 'react';

const ColumnBoxes = ({ columnBoxes, loading }) => {

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    return (
        <Box
            sx={{
                backgroundColor: '#F0F0F0',
                paddingTop: '20px',
                paddingBottom: '60px',
            }}
        >
            { loading ? 
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{
                        maxWidth: '250px',
                        margin: 'auto',
                        padding: '30px',
                    }}
                />
            :
                <Typography
                    variant="h2"
                    align="center"
                    sx={{
                        padding: '30px 24px',
                        lineHeight: '1.5',
                        color: '#265DA5',
                        fontSize: '1.3rem',
                        fontWeight: '600',
                    }}
                >
                    {columnBoxes?.intro}
                </Typography>
            }
            <Container 
                maxWidth="xl"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                }}
            >
                { loading ?
                    <>
                        {Array(2).fill().map((_, i) => {
                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        padding: '30px',
                                        backgroundColor: 'white',
                                        position: 'relative',
                                        width: mobile ? '100%' : 'calc(50% - 15px)',
                                        marginBottom: mobile ? '20px' : '0',
                                        height: '312px',
                                        marginTop: '20px',
                                    }}
                                >
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height="40px"
                                    />
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height="40px"
                                    />
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height="40px"
                                    />
                                </Box>
                            );
                        })}
                    </>
                :
                    <>
                        {columnBoxes?.box?.map((columnBox, i) => {
                        // console.log(columnBox)
                        return columnBox?.featured_image && columnBox?.featured_image !== '' ?
                        (
                            <Box
                                key={i}
                                sx={{
                                    padding: 0,
                                    backgroundColor: 'transparent',
                                    position: 'relative',
                                    width: mobile ? '100%' : 'calc(50% - 15px)',
                                    marginBottom: mobile ? '20px' : '0',
                                }}
                            >
                                <img
                                    src={columnBox?.featured_image?.url}
                                    alt={columnBox?.title}
                                    style={{
                                        width: '80%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                        display: 'flex',
                                        margin: 'auto',
                                    }}
                                />
                            </Box>
                        )
                        :
                        (
                            <Box
                                key={i}
                                sx={{
                                    padding: '30px',
                                    backgroundColor: 'white',
                                    position: 'relative',
                                    width: mobile ? '100%' : 'calc(50% - 15px)',
                                    marginBottom: mobile ? '20px' : '0',
                                }}
                            >
                                <Typography
                                    variant="h3"
                                    sx={{
                                        lineHeight: '1.4',
                                        color: '#265DA5',
                                        fontSize: '1.1rem',
                                        fontWeight: '600',
                                    }}
                                >
                                    {columnBox.title}
                                </Typography>
                                <Box
                                    sx={{
                                        width: '50px',
                                        height: '60px',
                                        position: 'absolute',
                                        top: '30px',
                                        right: '30px',
                                        '& svg': {
                                            width: '100%',
                                            maxHeight: '100%',
                                        }
                                    }}
                                    dangerouslySetInnerHTML={{ __html: columnBox.icon }}
                                />
                                <Box
                                    sx={{
                                        maxWidth: 'calc(100% - 60px)',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: columnBox.content }}
                                />
                            </Box>
                        )
                        })}
                    </>
                }
            </Container>
        </Box>
    );
}

export default ColumnBoxes;